import { generateSatellite, deleteSatellite } from '../SatelliteView/manageSatellite';
import '../../styles/switcherStyles.css';
class MapLibreStyleSwitcher {
    constructor(styles, options) {
        this.styles = styles || MapLibreStyleSwitcher.DEFAULT_STYLES;
        const defaultStyle = typeof (options) === 'string' ? options : options ? options.defaultStyle : undefined;
        this.defaultStyle = defaultStyle || MapLibreStyleSwitcher.DEFAULT_STYLE;
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.events = typeof (options) !== 'string' && options ? options.eventListeners : undefined;
    }
    getDefaultPosition() {
        const defaultPosition = 'top-right';
        return defaultPosition;
    }
    onAdd(map) {
        this.map = map;
        this.controlContainer = document.createElement('div');
        this.controlContainer.classList.add('maplibregl-ctrl');
        this.controlContainer.classList.add('maplibregl-ctrl-group');
        this.mapStyleContainer = document.createElement('div');
        this.styleButton = document.createElement('button');
        this.styleButton.type = 'button';
        this.mapStyleContainer.classList.add('maplibregl-style-list');
        for (const style of this.styles) {
            const styleElement = document.createElement('button');
            styleElement.type = 'button';
            styleElement.innerText = style.title;
            styleElement.style.fontFamily = 'inherit';
            styleElement.style.width = '100%';
            styleElement.style.textAlign = 'center';
            styleElement.style.padding = '0.5rem';
            styleElement.classList.add(style.title.replace(/[^a-z0-9-]/gi, '_'));
            styleElement.addEventListener('click', event => {
                const srcElement = event.target;
                this.closeModal();
                if (srcElement.classList.contains('active')) {
                    return;
                }
                if (this.events && this.events.onOpen && this.events.onOpen(event)) {
                    return;
                }
                switch (srcElement.className) {
                    case 'Satellite':
                        generateSatellite(map);
                        break;
                    case 'Streets':
                        deleteSatellite(map);
                        break;
                    default: throw new Error();
                }
                const elms = this.mapStyleContainer.getElementsByClassName('active');
                while (elms[0]) {
                    elms[0].classList.remove('active');
                }
                srcElement.classList.add('active');
            });
            if (style.title === this.defaultStyle) {
                styleElement.classList.add('active');
            }
            this.mapStyleContainer.appendChild(styleElement);
        }
        this.styleButton.classList.add('maplibregl-ctrl-icon');
        this.styleButton.classList.add('maplibregl-style-switcher');
        this.styleButton.addEventListener('click', event => {
            if (this.events && this.events.onSelect && this.events.onSelect(event)) {
                return;
            }
            this.openModal();
        });
        document.addEventListener('click', this.onDocumentClick);
        this.controlContainer.appendChild(this.styleButton);
        this.controlContainer.appendChild(this.mapStyleContainer);
        return this.controlContainer;
    }
    onRemove() {
        if (!this.controlContainer || !this.controlContainer.parentNode || !this.map || !this.styleButton) {
            return;
        }
        this.styleButton.removeEventListener('click', this.onDocumentClick);
        this.controlContainer.parentNode.removeChild(this.controlContainer);
        document.removeEventListener('click', this.onDocumentClick);
        this.map = undefined;
    }
    closeModal() {
        if (this.mapStyleContainer && this.styleButton) {
            this.mapStyleContainer.style.display = 'none';
            this.styleButton.style.display = 'block';
        }
    }
    openModal() {
        if (this.mapStyleContainer && this.styleButton) {
            this.mapStyleContainer.style.display = 'block';
            this.styleButton.style.display = 'none';
        }
    }
    onDocumentClick(event) {
        if (this.controlContainer && !this.controlContainer.contains(event.target)) {
            this.closeModal();
        }
    }
}
MapLibreStyleSwitcher.DEFAULT_STYLE = 'Streets';
MapLibreStyleSwitcher.DEFAULT_STYLES = [
    { title: 'Streets' },
    { title: 'Satellite' }
];
export const setStyleSwitcher = (map) => {
    const switcherControl = new MapLibreStyleSwitcher();
    map.addControl(switcherControl);
};
